// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import image01Icon from "@/assets/icons/image-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Image01IconProps = Omit<IconProps, "name">;

export function Image01Icon(props: Image01IconProps): React.ReactNode {
  return <Icon name={image01Icon} {...props} />;
}
